import { render, staticRenderFns } from "./SocialLinksSettings.vue?vue&type=template&id=09ab5c1c&scoped=true&"
import script from "./SocialLinksSettings.vue?vue&type=script&lang=js&"
export * from "./SocialLinksSettings.vue?vue&type=script&lang=js&"
import style0 from "./SocialLinksSettings.vue?vue&type=style&index=0&id=09ab5c1c&prod&lang=css&"
import style1 from "./SocialLinksSettings.vue?vue&type=style&index=1&id=09ab5c1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ab5c1c",
  null
  
)

export default component.exports